import { FullDate } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { removeMaskSpaces } from '@sravni/cosago-react-library/lib/utils';

import { useValidatePassportLinkedFieldsOnBlur } from '../../lib/useValidatePassportLinkedFieldsOnBlur';

export const PassportIssueDateField: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const handleBlur = useValidatePassportLinkedFieldsOnBlur(type);

  return (
    <FullDate
      {...props}
      type={type}
      onBlur={handleBlur}
      transformOutput={removeMaskSpaces}
    />
  );
};
